/* eslint-disable no-underscore-dangle */
var rafFallback = function rafFallback(handler) {
  return window.setTimeout(handler, 16);
};

var _requestAnimationFrame = window.requestAnimationFrame || rafFallback;

var _cancelAnimationFrame = window.cancelAnimationFrame || window.clearTimeout;
/**
 * @description requestAnimationFrame
 * @param  {()=>void} handler
 * @param  {number} timeout?
 */


export var raf = function raf(handler) {
  return _requestAnimationFrame.call(window, handler);
};
/**
 * @description cancelAnimationFrame
 * @param  {number} handle
 */

export var cancelRaf = function cancelRaf(handle) {
  _cancelAnimationFrame.call(window, handle);
};
/**
 * @description 为属性固定的静态对象赋值,例如reactive，替代通过.多次访问 减少代码量
 * @param  {Record<string, any>} target
 * @param  {Record<string, any>} source
 */

export function staticObjectAssign(target, source) {
  Object.keys(source).forEach(function (key) {
    if (source[key] !== undefined && Object.prototype.hasOwnProperty.call(target, key)) {
      target[key] = source[key];
    }
  });
}